import { DataItem } from 'scrivito'

import { Activity } from '@/Data/Activity/ActivityDataClass'
import { DataScopeOrder } from '@/Data/types'
import { useDataClassIndex } from '@/hooks/useDataClassIndex'

interface Args {
  subjectId: string
  search: string
  order: DataScopeOrder
  listSize: number
}

interface FollowUpRow {
  id: string
  followUp: DataItem
}

export const useFollowUpsTabData = ({
  subjectId,
  search,
  order,
  listSize,
}: Args) => {
  const { dataItems, hasMore, loadMore, count } = useDataClassIndex(
    Activity,
    {
      filters: { origin: subjectId },
      order: [order],
      search: search || undefined,
    },
    listSize,
  )

  const items: FollowUpRow[] = dataItems.map((followUp) => ({
    id: followUp.id(),
    followUp,
  }))

  return { items, hasMore, loadMore, count }
}
